module.exports = __webpack_public_path__ + "img/sharpandowen.ee264cdd.jpg";